import React from 'react';
import CookieConsent from 'react-cookie-consent';

export  function CookieBanner() {
	const handleAccept = () => {
		console.log('Cookies acceptés');

		if (typeof window.gtag === 'function') {
			window.gtag('consent', 'update', {
				analytics_storage: 'granted',
			});
		}
	};

	const handleDecline = () => {
		console.log('Cookies refusés');

		if (typeof window.gtag === 'function') {
			window.gtag('consent', 'update', {
				analytics_storage: 'denied',
			});
		}
	};
	return (
		<CookieConsent
			location='bottom'
			buttonText='Accepter'
			declineButtonText='Refuser'
			enableDeclineButton
			cookieName='epavistemoro_cookie_consent'
			style={{
				background: '#1f2937',
				padding: '20px',
				fontSize: '14px',
			}}
			buttonStyle={{
				background: '#10b981',
				color: 'white',
				fontSize: '13px',
				borderRadius: '8px',
				padding: '10px 16px',
			}}
			declineButtonStyle={{
				background: '#ef4444',
				color: 'white',
				fontSize: '13px',
				borderRadius: '8px',
				padding: '10px 16px',
			}}
			expires={150}
			onAccept={handleAccept}
			onDecline={handleDecline}
		>
			Ce site utilise des cookies pour améliorer votre expérience utilisateur, mesurer l’audience et proposer des services adaptés. Vous pouvez accepter
			ou refuser leur utilisation.
			<br />
			<a href='/politiquedeconfidentialite' style={{ color: '#60a5fa', textDecoration: 'underline' }}>
				En savoir plus
			</a>
		</CookieConsent>
	);
}
